import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { IInteriorDesignLibrary } from '@ml/common';
import { firstValueFrom } from 'rxjs';
import { Lookup } from '../shared/lookup';

@Injectable({
  providedIn: 'root'
})
export class InteriorDesignLibraryService {
  private http = inject(HttpClient);

  stageApiBase = window.location.protocol + '//' + Lookup.Argo.StageHost;
  cacheByClientId: Map<number, IInteriorDesignLibrary> = new Map();

  async getInteriorDesignsByClientId(
    clientId: number,
    includeGlobal: boolean = true
  ): Promise<IInteriorDesignLibrary> {
    if (this.cacheByClientId.has(clientId)) {
      return Promise.resolve(this.cacheByClientId.get(clientId));
    }

    const designs = await firstValueFrom(
      this.http.get<IInteriorDesignLibrary>(
        `${window.location.protocol}//${Lookup.Argo.StageHost}/api/interiordesignlibrary/client/${clientId}?includeGlobalDesigns=${includeGlobal}`
      )
    );

    this.cacheByClientId.set(clientId, designs);

    return designs;
  }
}
